import { Invite } from '@/domain/swing/event/taxi/Invite';

export default function EventTaxiInvite() {
  return <Invite />;
}